import { createContext, useContext } from 'react'

import { AnyRouter, RouteApi } from '@tanstack/react-router'
import { RelationshipsReportResponse } from '~bank-reports/types/RelationshipsReport'

type ApplicationPipelineReportContextValue = {
  data: RelationshipsReportResponse
  isFetching: boolean
  routeApi: RouteApi<'/_app/reports/relationships', AnyRouter>
}

export const RelationshipsReportContext = createContext<ApplicationPipelineReportContextValue | null>(null)

export const useRelationshipsReportContext = () => {
  const context = useContext(RelationshipsReportContext)
  if (!context) {
    throw new Error('useRelationshipsReportContext must be used within a RelationshipsReportContext.Provider')
  }
  return context
}
